import React from 'react'
export const generateLinkedInAuthUrl = (isRegister: boolean = false) => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: `${LINKEDIN_CONFIG.clientId}`,
    redirect_uri: `${LINKEDIN_CONFIG.redirect}`,
    state: `${LINKEDIN_CONFIG.state?.toString()}-${isRegister ? 'register' : 'login'}`,
    scope: 'openid email profile',
  })

  return `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`
}

// LinkedIn Icon Component
// export const LinkedInIcon = ({ className = 'w-5 h-5' }: { className?: string }) => (
//   <svg className={className} viewBox='0 0 24 24' fill='currentColor'>
//     <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' />
//   </svg>
// )

// Loading Spinner Component
// export const LoadingSpinner = ({ className = 'w-5 h-5' }: { className?: string }) => (
//   <svg className={`animate-spin ${className}`} fill='none' viewBox='0 0 24 24'>
//     <circle
//       className='opacity-25'
//       cx='12'
//       cy='12'
//       r='10'
//       stroke='currentColor'
//       strokeWidth='4'
//     ></circle>
//     <path
//       className='opacity-75'
//       fill='currentColor'
//       d='m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
//     ></path>
//   </svg>
// )

// Alert Component
export const Alert = ({
  type,
  children,
}: {
  type: 'success' | 'error'
  children: React.ReactNode
}) => (
  <div
    className={`p-4 rounded-lg mb-4 ${
      type === 'success'
        ? 'bg-green-50 text-green-800 border border-green-200'
        : 'bg-red-50 text-red-800 border border-red-200'
    }`}
  >
    {children}
  </div>
)

export const LINKEDIN_CONFIG = {
  response_type: 'code',
  clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID as string,
  redirect: process.env.REACT_APP_LINKEDIN_REDIRECT_URI as string,
  scope: 'openid email profile',
  state: Math.random().toString(36).substring(2, 15),
}
